<template>
  <b-modal
    v-model="visible"
    :title="isEdit ? 'Editar ruta' : 'Nueva ruta'"
    size="md"
    hide-footer
    no-close-on-backdrop
  >
    <validation-observer ref="rules">
      <b-form @submit.prevent="onSubmit">
        <validation-provider
          v-slot="{ errors }"
          name="nombre"
          rules="required"
        >
          <b-form-group
            label="Nombre:"
            label-for="route-name"
          >
            <b-form-input
              id="route-name"
              v-model="form.name"
              placeholder="Ej. Ruta Centro"
              required
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </b-form-group>
        </validation-provider>

        <b-form-group
          label="Descripción:"
          label-for="route-description"
        >
          <b-form-input
            id="route-description"
            v-model="form.description"
            placeholder="Descripción opcional"
          />
        </b-form-group>

        <b-form-group
          label="Vendedor asignado:"
          label-for="route-user"
        >
          <v-select
            id="route-user"
            v-model="form.user_id"
            :options="vendors"
            label="name"
            :reduce="vendor => vendor.id"
            placeholder="Sin vendedor"
            :clearable="true"
          />
          <small class="text-muted">
            Al asignar un vendedor, todos los clientes de esta ruta tendrán ese vendedor automáticamente.
          </small>
        </b-form-group>

        <b-form-group
          label="Estado:"
          label-for="route-status"
        >
          <b-form-select
            id="route-status"
            v-model="form.status"
            :options="statusOptions"
          />
        </b-form-group>

        <div class="d-flex justify-content-end mt-2">
          <b-button
            variant="outline-secondary"
            class="mr-1"
            @click="close"
          >
            Cancelar
          </b-button>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="primary"
            :disabled="saving"
          >
            {{ isEdit ? 'Actualizar' : 'Crear' }}
          </b-button>
        </div>
      </b-form>
    </validation-observer>
  </b-modal>
</template>

<script>
import axios from '@axios'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import { required } from '@/utils/validations/validations'

export default {
  name: 'CustomerRouteFormModal',

  components: {
    ValidationObserver,
    ValidationProvider,
    vSelect,
  },

  directives: {
    Ripple,
  },

  props: {
    show: {
      type: Boolean,
      required: true,
    },
    route: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      required,
      saving: false,
      vendors: [],
      form: {
        name: '',
        description: '',
        user_id: null,
        status: 'Y',
      },
      statusOptions: [
        { value: 'Y', text: 'Activo' },
        { value: 'N', text: 'Inactivo' },
      ],
    }
  },

  computed: {
    visible: {
      get() {
        return this.show
      },
      set(value) {
        this.$emit('update:show', value)
      },
    },
    isEdit() {
      return !!(this.route && this.route.id)
    },
  },

  watch: {
    show(newVal) {
      if (newVal) {
        this.loadVendors()
        this.hydrateForm()
      }
    },
  },

  methods: {
    hydrateForm() {
      if (this.isEdit) {
        this.form.name = this.route.name || ''
        this.form.description = this.route.description || ''
        this.form.user_id = this.route.user_id || null
        this.form.status = this.route.status || 'Y'
      } else {
        this.form.name = ''
        this.form.description = ''
        this.form.user_id = null
        this.form.status = 'Y'
      }
    },

    loadVendors() {
      const filterArray = [{ field: 'active', value: 'Y' }]
      axios
        .get(`system/users?filters=${JSON.stringify(filterArray)}&perPage=9999`)
        .then(response => {
          this.vendors = response.data.data || []
        })
        .catch(error => {
          this.showErrors(error)
        })
    },

    onSubmit() {
      this.$refs.rules.validate().then(success => {
        if (!success) {
          this.makeToast('danger', 'Error', 'Revisa los campos obligatorios.')
          return
        }

        this.saving = true
        const request = this.isEdit
          ? axios.put(`customer-route/${this.route.id}`, this.form)
          : axios.post('customer-route', this.form)

        request
          .then(response => {
            const saved = response.data.data
            this.makeToast(
              'success',
              this.isEdit ? 'Ruta actualizada' : 'Ruta creada',
              `Se ${this.isEdit ? 'actualizó' : 'creó'} la ruta ${saved.name}.`,
            )
            this.$emit('saved', saved)
            this.close()
          })
          .catch(error => {
            this.showErrors(error)
          })
          .finally(() => {
            this.saving = false
          })
      })
    },

    close() {
      this.visible = false
    },

    makeToast(variant, title, message) {
      this.$bvToast.toast(message, { title, variant, solid: true })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
